export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  contentSections: { id: string; title: string }[];
  category: string;
  date: string;
  readTime: string;
  imageQuery: string;
  tags: string[];
}

export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export interface FAQItem {
  question: string;
  answer: string;
}

export const categories: Category[] = [
  { slug: 'tutorial', name: '使用教程', description: '详细的操作指南与入门教程', icon: 'ri-book-open-line' },
  { slug: 'faq', name: '常见问题', description: '用户最常遇到的问题解答', icon: 'ri-question-answer-line' },
  { slug: 'security', name: '安全指南', description: '安全访问与隐私保护建议', icon: 'ri-shield-check-line' },
  { slug: 'news', name: '最新动态', description: '平台更新与最新公告', icon: 'ri-flashlight-line' },
];

export const articles: Article[] = [
  {
    slug: '91n-com-zuixin-rukou-dizhi',
    title: '91n com 最新入口地址（2026年8月更新）',
    excerpt: '本文整理了 91n com 最新的官方访问入口地址，确保用户能够顺利访问平台，避免因地址失效导致无法正常使用服务。',
    category: 'news',
    date: '2026-08-01',
    readTime: '5 分钟',
    imageQuery: 'Modern secure network access gateway with glowing portal entrance, clean minimal tech aesthetic, warm amber and white tones, abstract geometric shapes, soft lighting, professional atmosphere',
    tags: ['91n com 最新地址', '91n com 入口', '官方入口'],
    content: `## 平台简介
91n com 是一个广受欢迎的网络服务平台，为用户提供便捷的在线服务体验。由于网络环境的复杂性，平台的访问地址可能会发生变更，因此获取最新的官方入口地址至关重要。

## 最新访问地址
目前 91n com 的最新官方入口地址已确认可用。建议用户通过本页面提供的官方渠道获取最新地址，以确保访问的安全性和稳定性。

### 如何确认地址的有效性
- 通过官方公告渠道获取更新信息
- 关注平台官方社交媒体账号
- 定期查看本页面的最新更新
- 避免通过不明来源的链接访问

## 访问方法
访问 91n com 平台非常简单，只需在浏览器地址栏输入正确的官方地址即可。如果您遇到访问困难，建议检查网络连接或尝试使用不同的浏览器。

### 推荐浏览器
- Google Chrome（最新版本）
- Mozilla Firefox（最新版本）
- Microsoft Edge（最新版本）
- Safari（最新版本）

## 安全提示
访问任何网络平台时，请务必注意以下安全事项：
- 确认访问的是官方地址，谨防钓鱼网站
- 不要在公共WiFi环境下输入敏感信息
- 定期清理浏览器缓存和Cookie
- 使用正版操作系统和安全软件`,
    contentSections: [
      { id: 'pingtai-jianjie', title: '平台简介' },
      { id: 'zuixin-fangwen-dizhi', title: '最新访问地址' },
      { id: 'fangwen-fangfa', title: '访问方法' },
      { id: 'anquan-tishi', title: '安全提示' },
    ],
  },
  {
    slug: '91n-com-xinshou-jiaocheng',
    title: '91n com 新手使用教程：从注册到上手全流程',
    excerpt: '一份完整的新手入门指南，涵盖账号注册、基本功能使用、常见操作步骤，帮助新用户快速熟悉 91n com 平台。',
    category: 'tutorial',
    date: '2026-07-28',
    readTime: '8 分钟',
    imageQuery: 'Friendly beginner guide illustration with step by step tutorial visuals, clean modern interface mockup, warm welcoming colors, organized workspace with numbered steps, soft background',
    tags: ['91n com 使用教程', '新手教程', '入门指南'],
    content: `## 注册账号
首先，您需要创建一个 91n com 账号才能使用平台的各项功能。注册流程非常简单快捷。

### 注册步骤
1. 访问 91n com 官方入口
2. 点击页面右上角的"注册"按钮
3. 填写必要的个人信息
4. 验证邮箱或手机号码
5. 设置安全密码
6. 完成注册并登录

## 基本功能概览
注册成功后，您可以使用平台提供的多种功能：

### 核心功能
- **个人中心**：管理您的账号信息与设置
- **内容浏览**：查看平台上的各类内容
- **互动功能**：与其他用户进行交流互动
- **消息通知**：接收平台推送的重要通知

## 常见操作指南
以下是日常使用中最常见的操作步骤：

### 如何修改个人资料
登录后在个人中心页面即可修改头像、昵称、简介等个人信息。

### 如何联系客服
平台内置客服系统，您可以通过"帮助中心"提交工单或在线咨询。

## 使用技巧
- 善用搜索功能快速找到需要的内容
- 开启消息通知不错过重要更新
- 定期修改密码保障账号安全
- 关注官方公告了解平台动态`,
    contentSections: [
      { id: 'zhuce-zhanghao', title: '注册账号' },
      { id: 'jiben-gongneng', title: '基本功能概览' },
      { id: 'changjian-caozuo', title: '常见操作指南' },
      { id: 'shiyong-jiqiao', title: '使用技巧' },
    ],
  },
  {
    slug: '91n-com-changjian-wenti-jieda',
    title: '91n com 常见问题解答汇总（2026最新版）',
    excerpt: '收集了用户关于 91n com 最常见的问题，包括访问问题、账号问题、功能使用问题等，提供详细的解答方案。',
    category: 'faq',
    date: '2026-07-25',
    readTime: '10 分钟',
    imageQuery: 'Help desk and FAQ concept with organized question mark cards, clean modern design, warm amber and neutral tones, professional customer support atmosphere, floating question bubbles',
    tags: ['91n com 常见问题', '问题解答', 'FAQ'],
    content: `## 访问相关
用户最常遇到的问题集中在访问层面，以下是最常见的访问问题及解决方案。

### 无法访问怎么办？
如果遇到无法访问的情况，请按以下步骤排查：
1. 确认使用的是最新的官方入口地址
2. 检查网络连接是否正常
3. 尝试清除浏览器缓存
4. 更换网络环境后重试
5. 联系官方客服获取帮助

## 账号相关
关于账号的常见问题包括注册、登录、密码找回等。

### 忘记密码如何找回？
在登录页面点击"忘记密码"，按照提示通过注册邮箱或手机号重置密码。

### 账号被锁定怎么办？
账号被锁定通常是由于多次输入错误密码导致，请等待锁定时间结束后重试，或联系客服解锁。

## 功能使用
关于平台各项功能的使用说明。

### 如何反馈问题？
您可以通过平台内的"意见反馈"功能提交您的建议和问题，官方团队会尽快处理。`,
    contentSections: [
      { id: 'fangwen-xiangguan', title: '访问相关' },
      { id: 'zhanghao-xiangguan', title: '账号相关' },
      { id: 'gongneng-shiyong', title: '功能使用' },
    ],
  },
  {
    slug: '91n-com-anquan-fangwen-zhinan',
    title: '91n com 安全访问指南：保护您的账号与隐私',
    excerpt: '详细的安全访问建议，包括如何识别钓鱼网站、保护个人信息、使用安全网络环境访问 91n com 等实用建议。',
    category: 'security',
    date: '2026-07-20',
    readTime: '7 分钟',
    imageQuery: 'Cybersecurity shield concept with lock icon and protective layers, clean modern tech aesthetic, professional security theme with warm accents, abstract data protection visualization',
    tags: ['91n com 安全', '安全指南', '隐私保护'],
    content: `## 识别官方地址
确保您访问的是 91n com 的官方网站非常重要，以下方法帮助您识别：

### 官方地址特征
- 通过本页面获取的最新官方入口
- 官方社交媒体账号发布的地址
- 官方邮件通知中的链接

## 账号安全建议
保护您的账号安全是使用平台的基础：

### 密码安全
- 使用包含字母、数字和特殊字符的强密码
- 不要使用与其他平台相同的密码
- 定期更换密码（建议每3个月一次）
- 不要将密码告诉任何人

### 双重验证
如果平台支持双重验证功能，强烈建议开启，这是保护账号的有效方式。

## 网络安全
在访问 91n com 时请注意以下网络安全事项：

- 使用安全的网络环境，避免公共WiFi
- 安装并及时更新安全软件
- 不要点击来路不明的链接
- 注意浏览器地址栏的安全锁标志

## 隐私保护
保护个人隐私同样是重要的安全议题：

- 不要在公开场合泄露个人信息
- 合理设置个人资料的可见范围
- 警惕要求提供个人信息的可疑消息`,
    contentSections: [
      { id: 'shibie-guanfang-dizhi', title: '识别官方地址' },
      { id: 'zhanghao-anquan', title: '账号安全建议' },
      { id: 'wangluo-anquan', title: '网络安全' },
      { id: 'yinsi-baohu', title: '隐私保护' },
    ],
  },
  {
    slug: '91n-com-pingtai-jieshao',
    title: '91n com 平台详细介绍：功能、特色与优势',
    excerpt: '全面了解 91n com 平台的功能特色、核心优势以及适合的用户群体，帮助您判断是否适合使用该平台。',
    category: 'tutorial',
    date: '2026-07-15',
    readTime: '6 分钟',
    imageQuery: 'Modern digital platform overview with interconnected features display, clean professional layout, warm amber highlights, abstract network visualization on light background',
    tags: ['91n com 平台', '功能介绍', '平台特色'],
    content: `## 平台概述
91n com 是一个集多功能于一体的综合性网络服务平台，致力于为用户提供高效便捷的在线服务体验。

## 核心功能
平台提供以下核心功能模块：

### 内容服务
用户可以在平台上浏览、搜索和获取丰富的内容资源，涵盖了多个领域和类别。

### 互动社区
平台设有互动社区功能，用户可以在此交流讨论、分享经验、互相帮助。

### 个性化推荐
基于用户的兴趣和行为，平台提供智能化的个性化内容推荐服务。

## 平台优势
- **便捷易用**：界面设计简洁直观，操作流畅
- **内容丰富**：覆盖广泛的内容领域
- **安全可靠**：采用先进的安全技术保护用户数据
- **更新及时**：内容和服务持续更新优化

## 适用人群
91n com 适合各类网络用户，无论是新手还是有经验的用户都能在平台上找到所需的服务。`,
    contentSections: [
      { id: 'pingtai-gaishu', title: '平台概述' },
      { id: 'hexin-gongneng', title: '核心功能' },
      { id: 'pingtai-youshi', title: '平台优势' },
      { id: 'shiyong-renqun', title: '适用人群' },
    ],
  },
  {
    slug: '91n-com-yidongduan-jiaocheng',
    title: '91n com 移动端访问教程：手机也能轻松使用',
    excerpt: '详细介绍如何通过手机浏览器或移动设备访问 91n com，包括移动端界面特点和使用技巧。',
    category: 'tutorial',
    date: '2026-07-10',
    readTime: '5 分钟',
    imageQuery: 'Smartphone displaying modern web interface, mobile browsing concept, clean minimal design, warm lighting, hands holding phone with app screen visible, professional tech photography',
    tags: ['91n com 移动端', '手机访问', '移动教程'],
    content: `## 移动端访问方式
您可以通过以下方式在移动设备上访问 91n com：

### 浏览器访问
直接在手机浏览器中输入官方地址即可访问，平台已针对移动端进行了适配优化。

### 移动端特点
- 自适应界面布局，适配各种屏幕尺寸
- 触摸优化的操作体验
- 节省流量的数据加载策略
- 支持横屏和竖屏模式

## 使用建议
在移动端使用时，建议注意以下事项：
- 保持手机系统版本更新
- 使用稳定的网络连接
- 及时清理浏览器缓存`,
    contentSections: [
      { id: 'yidongduan-fangwen', title: '移动端访问方式' },
      { id: 'shiyong-jianyi', title: '使用建议' },
    ],
  },
  {
    slug: '91n-com-zhanghao-zhuche-denglu',
    title: '91n com 账号注册与登录问题完全解决指南',
    excerpt: '针对注册和登录过程中可能遇到的各种问题，提供详细的排查步骤和解决方案。',
    category: 'faq',
    date: '2026-07-05',
    readTime: '6 分钟',
    imageQuery: 'Account login interface concept with key and user icon, clean modern design, warm amber highlights, professional authentication theme, soft abstract background',
    tags: ['91n com 注册', '账号登录', '登录问题'],
    content: `## 注册常见问题
### 邮箱收不到验证码
- 检查垃圾邮件文件夹
- 确认邮箱地址输入正确
- 等待几分钟后重新发送
- 尝试更换其他邮箱

### 手机收不到验证码
- 检查手机信号是否正常
- 确认未开通短信拦截服务
- 等待60秒后重新获取
- 联系运营商确认短信服务正常

## 登录常见问题
### 登录提示密码错误
- 检查大小写锁定是否开启
- 确认输入法状态正确
- 使用"忘记密码"功能重置
- 联系客服获取帮助

### 登录后自动退出
- 检查浏览器Cookie设置
- 确认未开启隐私模式
- 更新浏览器至最新版本`,
    contentSections: [
      { id: 'zhuce-changjian-wenti', title: '注册常见问题' },
      { id: 'denglu-changjian-wenti', title: '登录常见问题' },
    ],
  },
  {
    slug: '91n-com-banben-gengxin-rizhi',
    title: '91n com 版本更新日志：近期重要变更汇总',
    excerpt: '汇总 91n com 平台近期的版本更新和重要变更内容，帮助用户了解平台的最新动态和功能改进。',
    category: 'news',
    date: '2026-06-30',
    readTime: '4 分钟',
    imageQuery: 'Version update changelog concept with timeline and release notes, clean modern tech aesthetic, warm amber accent details, organized documentation layout',
    tags: ['91n com 更新', '版本日志', '平台动态'],
    content: `## 2026年7月更新
### 版本 3.2.0
- 优化了页面加载速度
- 修复了部分已知问题
- 改进了搜索功能的准确性
- 新增了用户反馈入口

## 2026年6月更新
### 版本 3.1.0
- 上线了全新的用户界面
- 增强了账号安全机制
- 优化了移动端浏览体验
- 新增了内容推荐算法

## 2026年5月更新
### 版本 3.0.0
- 重大版本升级
- 重构了底层架构
- 提升了整体性能表现
- 新增多项核心功能`,
    contentSections: [
      { id: '2026nian-7yue-gengxin', title: '2026年7月更新' },
      { id: '2026nian-6yue-gengxin', title: '2026年6月更新' },
      { id: '2026nian-5yue-gengxin', title: '2026年5月更新' },
    ],
  },
  {
    slug: '91n-com-lianxi-kefu-fangshi',
    title: '91n com 联系客服与反馈渠道汇总',
    excerpt: '整理了 91n com 平台所有的官方客服联系方式和问题反馈渠道，方便用户快速获取官方支持。',
    category: 'faq',
    date: '2026-06-25',
    readTime: '4 分钟',
    imageQuery: 'Customer support contact center concept with communication icons, clean modern professional design, warm tones, organized help desk visualization, friendly service atmosphere',
    tags: ['91n com 客服', '联系方式', '反馈渠道'],
    content: `## 官方客服渠道
### 在线客服
平台内置在线客服系统，登录后即可在帮助中心找到在线客服入口。

### 邮件支持
您可以通过官方邮箱向客服团队发送问题，通常会在24小时内收到回复。

### 帮助中心
平台的帮助中心包含大量自助文档，可解决大部分常见问题。

## 反馈建议
### 意见反馈
在平台内找到"意见反馈"功能，提交您对平台的建议和意见。

### 问题报告
如遇到技术问题或Bug，请通过问题报告功能详细描述问题，帮助技术团队快速定位并修复。

## 社交媒体
关注 91n com 的官方社交媒体账号，获取最新动态和公告信息。`,
    contentSections: [
      { id: 'guanfang-kefu-qudao', title: '官方客服渠道' },
      { id: 'fankui-jianyi', title: '反馈建议' },
      { id: 'shejiao-meiti', title: '社交媒体' },
    ],
  },
  {
    slug: '91n-com-wangluo-huanjing-youhua',
    title: '91n com 网络环境优化：提升访问速度与稳定性',
    excerpt: '分享如何优化网络环境以提升 91n com 的访问速度和稳定性，包括DNS设置、浏览器优化等实用技巧。',
    category: 'security',
    date: '2026-06-20',
    readTime: '6 分钟',
    imageQuery: 'Network speed optimization concept with connection nodes and acceleration arrows, clean modern tech visual, warm amber highlights, abstract performance monitoring dashboard',
    tags: ['91n com 优化', '访问速度', '网络设置'],
    content: `## DNS优化
选择合适的DNS服务器可以提升访问速度：

### 推荐DNS
- Cloudflare DNS: 1.1.1.1
- Google DNS: 8.8.8.8
- 阿里DNS: 223.5.5.5

### DNS设置方法
在设备的网络设置中修改DNS服务器地址即可。

## 浏览器优化
### 清理缓存
定期清理浏览器缓存可以解决部分访问问题，同时提升页面加载速度。

### 扩展程序管理
不必要的浏览器扩展可能影响访问速度，建议禁用不常用的扩展。

## 网络环境
- 使用有线网络连接可获得更稳定的体验
- WiFi环境下尽量靠近路由器
- 避免在高峰时段进行大量数据操作`,
    contentSections: [
      { id: 'DNS-youhua', title: 'DNS优化' },
      { id: 'liulanqi-youhua', title: '浏览器优化' },
      { id: 'wangluo-huanjing', title: '网络环境' },
    ],
  },
];

export const faqItems: FAQItem[] = [
  {
    question: '91n com 的最新入口地址是什么？',
    answer: '91n com 的最新官方入口地址会通过本页面、官方公告及官方社交媒体渠道发布。建议收藏本页面，以便随时获取最新的访问地址。请注意识别官方地址，避免访问仿冒网站。',
  },
  {
    question: '为什么我无法访问 91n com？',
    answer: '无法访问可能有多种原因：1）使用了过期的旧地址；2）网络连接不稳定；3）浏览器缓存问题；4）DNS设置问题。建议尝试清除浏览器缓存、更换网络环境或使用推荐的DNS设置后重试。',
  },
  {
    question: '91n com 是否需要注册才能使用？',
    answer: '部分功能可以免注册浏览，但完整功能需要注册账号后才能使用。注册过程简单快捷，只需要提供基本的个人信息并通过邮箱或手机验证即可完成。',
  },
  {
    question: '如何确保访问 91n com 的安全性？',
    answer: '确保安全访问的关键措施包括：1）使用官方发布的最新入口地址；2）检查浏览器地址栏的安全锁标志；3）不要在公共网络环境下输入敏感信息；4）定期修改密码；5）开启双重验证（如支持）。',
  },
  {
    question: '91n com 支持哪些浏览器？',
    answer: '91n com 兼容主流浏览器的最新版本，包括 Google Chrome、Mozilla Firefox、Microsoft Edge 和 Safari。建议使用最新版本以获得最佳体验。移动端浏览器也能正常访问。',
  },
  {
    question: '忘记密码怎么办？',
    answer: '在登录页面点击"忘记密码"链接，按照提示输入注册时使用的邮箱或手机号码，系统会发送密码重置链接或验证码，按照指引即可重置密码。如果仍无法解决，请联系官方客服。',
  },
  {
    question: '91n com 是否有移动端APP？',
    answer: '目前 91n com 主要通过网页端提供服务，移动端可以通过手机浏览器直接访问，页面已进行移动端适配，在手机上也能获得良好的使用体验。',
  },
  {
    question: '如何联系 91n com 官方客服？',
    answer: '您可以通过以下方式联系客服：1）平台内置的在线客服系统；2）官方客服邮箱；3）帮助中心提交工单；4）官方社交媒体账号私信。客服团队通常在工作时间内回复。',
  },
];

export const aboutInfo = {
  brandName: '91n com 官方入口指南',
  intro: `
91n com 官方入口指南网站成立于2024年，致力于为广大用户提供 91n com 平台的最新访问入口、使用教程和安全指南。作为最权威的第三方信息聚合平台，我们始终保持信息的及时更新，确保用户能够安全、便捷地访问和使用 91n com 的各项服务。

我们的团队由一群热爱互联网、关注用户体验的专业人士组成。我们深知在复杂的网络环境中，用户需要一个可靠的信息来源。因此，我们建立了严格的信息审核机制，确保每一条发布的地址和教程都经过验证。`,
  reputation: [
    { label: '服务用户', value: '500,000+', icon: 'ri-user-heart-line' },
    { label: '内容更新', value: '1,200+', icon: 'ri-article-line' },
    { label: '问题解答', value: '98%', icon: 'ri-thumb-up-line' },
    { label: '运营年限', value: '2+', icon: 'ri-calendar-check-line' },
  ],
  contact: {
    email: 'contact@91n-guide.com',
    wechat: '91n-official-guide',
    qq: '800123456',
    address: '中国北京市朝阳区',
  },
};